import { render, staticRenderFns } from "./form-cell.vue?vue&type=template&id=2bfa7b87&scoped=true"
import script from "./form-cell.ts?vue&type=script&lang=ts&external"
export * from "./form-cell.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bfa7b87",
  null
  
)

export default component.exports